import { instanceReadStatisticsWithKey } from 'client/redux/instance/actionCreators';
import { INSTANCE_AITD_READ_STATISTICS } from 'client/redux/aitd/constants';

export const instanceAitdReadStatistics = (id, key, statistic, query) => dispatch => {
  switch (statistic) {
    default: return dispatch(instanceReadStatisticsWithKey(INSTANCE_AITD_READ_STATISTICS, id, key, statistic, query));
  }
};
